





























import { UiIconButton } from '../keen-ui';
import TransitionHeight from '../transition-height.component.vue';

export default {
  name: 'explain-results-row',
  props: {
    resultIds: {
      type: Array,
      required: true
    },
    color: String,
    level: {
      type: Number,
      default: 0
    },
    childrenExpanded: Boolean
  },
  components: {
    UiIconButton,
    TransitionHeight
  },
  computed: {
    rowClasses: function (): string[] {
      const classes = [];
      const baseClass = 'epb-explain-results-row';
      if (this.resultIds.length === 1) {
        classes.push(`${ baseClass }--single-result`);
      }
      if (!!this.color) {
        classes.push(`${ baseClass }--${ this.color }`);
      } else {
        classes.push(`${ baseClass }--default-color`);
      }
      classes.push(`${ baseClass }--level-${ this.level }`);
      return classes;
    }
  }
};
